module.exports = __webpack_public_path__ + "static/media/default-picture5.07f619f8.svg";